module.exports = __webpack_public_path__ + "img/10_college.74b8e730.png";